import { traducirButton, traducirLabel, traducirMessage } from "../blocks/traductor";
import { enums } from "../enums/enums";



export const Defaults: any = {
    Mexico: enums.pais.mexico,
    tipoPersonaId: enums.tipoPersona.particular,
    campoRequerido: traducirLabel(126), // "Este campo es requerido.",
    emailInvalido: traducirLabel(55), //"Correo Invalido.",
    telefonoInvalido: traducirLabel(293), // "Teléfono Invalido.",
    caracterInvalido: traducirMessage(203), // "No se permiten los caracteres especiales <> en este campo.",
};
